const isSectionPath = (path: string, section: string): boolean => path === section || path.startsWith(`${section}/`)

export function isAgencyRouteAllowed(
  path: string,
  canManageUsers: () => boolean,
  canManageClients: () => boolean,
): boolean {
  if (path === '/clients/no_access') {
    return true
  }

  if (isSectionPath(path, '/clients')) {
    return canManageClients()
  }

  if (isSectionPath(path, '/team')) {
    return canManageUsers()
  }

  if (path === '/agency') {
    return canManageUsers() || canManageClients()
  }

  return true
}
